import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoRoutingModule } from './bo-routing.module';

import { ClientsComponent } from './clients/clients.component';
import { OrdersComponent } from './orders/orders.component';
import { AccountComponent } from './account/account.component';
import { UsersComponent } from './users/users.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { OrderDetailsComponent } from './order-details/order-details.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { OrderManagementComponent } from './order-management/order-management.component';
import { DeliveryEstimateComponent } from './delivery-estimate/delivery-estimate.component';
import { OrderDeleteComponent } from './order-delete/order-delete.component';
import { ClientInfosComponent } from './client-infos/client-infos.component';
import { FicheChantierInfosComponent } from './fiche-chantier-infos/fiche-chantier-infos.component';
import { FicheClientInfosComponent } from './fiche-client-infos/fiche-client-infos.component';
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { AccountAdminComponent } from './account-admin/account-admin.component';
import { AccountDeletionComponent } from './account-deletion/account-deletion.component';
import { AccountShopComponent } from './account-shop/account-shop.component';
import { AccountModificationComponent } from './account-modification/account-modification.component';
import { AccountProviderComponent } from './account-provider/account-provider.component';
import { LoginComponent } from './login/login.component';
import { AccountModificationPwdComponent } from './account-modification-pwd/account-modification-pwd.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { RenewPasswordComponent } from './renew-password/renew-password.component';
import { UserModificationComponent } from './user-modification/user-modification.component';
import { UserInfosComponent } from './user-infos/user-infos.component';
import { UserCreationComponent } from './user-creation/user-creation.component';
import { UserProviderComponent } from './user-provider/user-provider.component';
import { UserShopComponent } from './user-shop/user-shop.component';
import { FicheClientComponent } from './fiche-client/fiche-client.component';
import { FicheChantierComponent } from './fiche-chantier/fiche-chantier.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { StatusOrderExplicationComponent } from './status-order-explication/status-order-explication.component';
import { HealthCheckComponent } from './health-check/health-check.component';
import { UserPaymentComponent } from './user-payment/user-payment.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    ClientsComponent,
    OrdersComponent,
    AccountComponent,
    UsersComponent,
    OrderDetailsComponent,
    OrderManagementComponent,
    DeliveryEstimateComponent,
    OrderDeleteComponent,
    ClientInfosComponent,
    AccountAdminComponent,
    FicheClientInfosComponent,
    FicheClientComponent,
    AccountDeletionComponent,
    FicheChantierInfosComponent,
    FicheChantierComponent,
    AccountShopComponent,
    AccountModificationComponent,
    AccountProviderComponent,
    LoginComponent,
    AccountModificationPwdComponent,
    ForgetPasswordComponent,
    RenewPasswordComponent,
    UserModificationComponent,
    UserInfosComponent,
    UserCreationComponent,
    UserProviderComponent,
    UserShopComponent,
    StatusOrderExplicationComponent,
    HealthCheckComponent,
    UserPaymentComponent,
  ],
  imports: [
    NgxDatatableModule,
    CommonModule,
    BoRoutingModule,
    NgbModule,
    ToastrModule.forRoot(),
    FormsModule,
    MatRadioModule,
    MatSelectModule,
    MatOptionModule,
    MatPasswordStrengthModule,
    MatFormFieldModule,
    MatTabsModule,
    MatInputModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  entryComponents: [OrderDetailsComponent, OrderManagementComponent, DeliveryEstimateComponent, OrderDeleteComponent],
  exports: [DeliveryEstimateComponent],
  bootstrap: [DeliveryEstimateComponent],
})
export class BoModule {}
